import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SEO } from "@/components/SEO";
import { Home, Search, ArrowLeft } from "lucide-react";
import { analytics } from "@/lib/analytics";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.track('404_error', { path: location.pathname });
  }, [location.pathname]);

  return (
    <>
      <SEO 
        title="Page Not Found"
        description="The page you're looking for doesn't exist."
      />
      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <Card className="max-w-md w-full">
          <CardContent className="p-8 text-center space-y-6">
            {/* 404 Illustration */}
            <div className="relative">
              <div className="text-9xl font-bold text-primary/10">404</div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Search className="h-20 w-20 text-muted-foreground" />
              </div>
            </div>

            {/* Error Message */}
            <div className="space-y-2">
              <h1 className="text-3xl font-bold text-foreground">Page Not Found</h1>
              <p className="text-muted-foreground">
                Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
              </p>
              <p className="text-sm text-muted-foreground">
                Path: <code className="bg-muted px-2 py-1 rounded">{location.pathname}</code>
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 pt-4">
              <Button 
                onClick={() => window.history.back()} 
                variant="outline" 
                className="flex-1"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back
              </Button>
              <Link to="/" className="flex-1">
                <Button className="w-full">
                  <Home className="h-4 w-4 mr-2" />
                  Home
                </Button>
              </Link>
            </div>

            {/* Helpful Links */}
            <div className="pt-6 border-t">
              <p className="text-sm text-muted-foreground mb-3">Looking for something?</p>
              <div className="flex flex-wrap gap-2 justify-center">
                <Link to="/discover">
                  <Button variant="link" size="sm">Discover Streams</Button>
                </Link>
                <Link to="/creator">
                  <Button variant="link" size="sm">Creator Dashboard</Button>
                </Link>
                <Link to="/wallet">
                  <Button variant="link" size="sm">Wallet</Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default NotFound;
